import { map } from 'lodash/fp';
import React from 'react';

import { StyledList } from './styles';

type Props = {
  isVertical?: boolean;
  steps: string[];
};

const StepList = ({ isVertical = false, steps }: Props) => (
  <StyledList isVertical={isVertical}>
    {map(
      (step) => (
        <li key={step}>{step}</li>
      ),
      steps,
    )}
  </StyledList>
);

export default StepList;
